import React from 'react';
import PropTypes from 'prop-types';
import { components } from 'react-select';
import { ChevronDownIcon, ChevronUpIcon } from '@pattern-library/icon';
const DropdownIndicator = props => {
  const {
    selectProps: {
      menuIsOpen,
      useNextUI
    }
  } = props;
  return useNextUI ? /*#__PURE__*/React.createElement(components.DropdownIndicator, props, menuIsOpen ? /*#__PURE__*/React.createElement(ChevronUpIcon, {
    size: "xs",
    color: "dark-gray"
  }) : /*#__PURE__*/React.createElement(ChevronDownIcon, {
    size: "xs",
    color: "dark-gray"
  })) : /*#__PURE__*/React.createElement(components.DropdownIndicator, props);
};
DropdownIndicator.propTypes = {
  selectProps: PropTypes.object
};
export default DropdownIndicator;